<!-- <h2 mat-dialog-title>Document</h2> -->
<mat-dialog-content class="mat-typography">
    <div *ngIf="pdfUrl" class="image-wrapper">
        <iframe [src]="sanitizePdfUrl(pdfUrl)" style="width:100%; height:100%;" frameborder="0"></iframe>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <!-- <button mat-button mat-dialog-close>Cancel</button> -->
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Close</button>
</mat-dialog-actions>
